/**
 * Live-sessions API layer — "users currently in session, ordered by highest
 * usage" (SCRUM admin-wave). Types mirror
 * `apps/api/garden/features/admin_metrics/schemas.py`'s `LiveSessionUser` /
 * `LiveSessionsResponse`. Gated server-side on `ops.metrics.read` (same
 * permission as every sibling `/admin/metrics/*` tile) and returns ONLY a
 * PII-safe projection (id, display_name, email — mirrors `AdminUserDto`,
 * never phone/password).
 */
import { apiClient } from "@/lib/api-client";

export type LiveSessionsOrderBy = "chat_hour" | "cost";
export type LimitStatus = "ok" | "near" | "at";

export interface LiveSessionUser {
  user_id: string;
  email: string;
  display_name: string;
  session_count: number;
  chat_requests_hour: number;
  chat_requests_min: number;
  hour_window_reset_seconds: number | null;
  limit_status: LimitStatus;
  input_tokens_today: number;
  output_tokens_today: number;
  cost_tiyin_today: number;
  cost_kgs_today: number;
}

export interface LiveSessionsResponse {
  users: LiveSessionUser[];
  order_by: LiveSessionsOrderBy;
  scanned_keys: number;
  truncated: boolean;
}

export function getLiveSessions(
  orderBy: LiveSessionsOrderBy,
): Promise<LiveSessionsResponse> {
  return apiClient.get<LiveSessionsResponse>(
    `/admin/metrics/live-sessions?order_by=${orderBy}`,
  );
}
